import z from 'zod';

export const GetLikedSnapsCountServiceRequestSchema = z
  .object({
    ids: z.array(z.string()),
  })
  .describe('GetLikedSnapsCountServiceRequestSchema');

export type GetLikedSnapsCountServiceRequest = z.infer<
  typeof GetLikedSnapsCountServiceRequestSchema
>;

const LikedSnapsCountEntrySchema = z
  .object({
    isLiked: z.boolean(),
    likeCount: z.number().int().nonnegative(),
  })
  .describe('LikedSnapsCountEntrySchema');

export const LikedSnapsCountMapSchema = z
  .record(z.string(), LikedSnapsCountEntrySchema)
  .describe('LikedSnapsCountMapSchema');

export type LikedSnapsCountEntry = z.infer<typeof LikedSnapsCountEntrySchema>;
export type LikedSnapsCountMap = z.infer<typeof LikedSnapsCountMapSchema>;
